'use client';

import { TSourceVariants } from '@northladder/services';

import { UserAvatar, TVariants } from '../../../../UserAvatar';

import { Actions, IAction } from './Actions';
import {
  CreatorIdentifier,
  ICreatorIdentifierProps,
} from './CreatorIdentifier';

export interface IMetaDataOptions extends ICreatorIdentifierProps {
  actions?: IAction[];
  variant: TSourceVariants;
}

interface IMetaDataProps extends IMetaDataOptions {}

/**
 * -----------------------------------------------------------------------------
 * It renders a meta data with a creator identifier and user avatar
 */
export function MetaData({ actions, name, variant }: Readonly<IMetaDataProps>) {
  // TODO: add logic for handling actions
  const handleOnClickUserAvatar = () => {};

  let avatarVariant: TVariants = {
    type: 'initials',
    initials: 'JS',
  };

  if (variant.userType === 'customer') {
    avatarVariant.initials = variant.initials;
  }

  if (variant.userType === 'admin') {
    avatarVariant = {
      type: 'staff',
    };
  }

  return (
    <div className="flex items-center gap-1">
      <div>
        <CreatorIdentifier name={name} />
      </div>

      <UserAvatar
        onClick={handleOnClickUserAvatar}
        size="small"
        variant={avatarVariant}
      />
      {actions ? <Actions actions={actions} /> : null}
    </div>
  );
}
